// 
import {Component} from 'react';
import {RadioBox} from './radiobox';
import {FormError} from './form-errors';
import {MontantInput} from  './montant-input';
import InfoBulle from './info';
// 
import Startscreen from './Startscreen';
import ResultScreen from './ResultScreen';
// images 
import Boulier from './boulier';
import triangle from './img/triangle.png';
import trianglebas from './img/triangle-bas.png';
import logo from './img/logo-bleu.png';


class Simulateur extends Component{
	state = {
		utiliseVoiture: null,
		conjointUtiliseVoiture :null,
		hasEnfant :false,
		nombreEnfant :"" ,

		enCouple:false,
		montantRFR : "",
		statutMarital:"",
		step : 0,
		optionsStatutMarital: [

		    { 
		      id: 1,
		      name: 'En Union Libre',
		      value :'non_renseigne',
		    },
	        {
	          id: 2,
	          name: 'Marié-e',
	          value:'marie',
	      	},
	        {
	          id: 3,
	          name: 'Pacsé-e',
	          value: 'pacse',
	      	}
		],
		errorMessage :[],
	}

	/* Capture réponse pour question couple */
	handleChangeEnCouple = (newValue) =>{
		newValue = JSON.parse(newValue);
		this.setState( ()=>({enCouple : newValue}));
	}

	/* Capture réponse pour question statut marital*/
	captureStatutMarital=(e) =>{
		const newVal  = e.target.value;
		this.setState( ()=>{
			return {statutMarital : newVal};
		}); 
	}
	/* capture réponse pour question enfant a charge*/
	handleChangeHasEnfant = (newValue)=>{
		this.setState(()=>({hasEnfant:JSON.parse(newValue)}));
	}

	/*capture nombre d'enfant */
	captureNombreEnfant =(e)=>{
		this.setState(()=>({nombreEnfant : parseInt(e.target.value) }));
	}

	/*capture utilisation voiture*/
	captureUseVoiture = (newVal)=>{
		this.setState(()=>({utiliseVoiture:JSON.parse(newVal)}));
	}
	/*utilisation voiture conjoint*/
	captureUseVoitureConjoint = (newVal)=>{
		this.setState(()=>({conjointUtiliseVoiture:JSON.parse(newVal)}));
	}

	/* Capture changement de montant pour un state*/
	handleMontantChange = (newValue , modelName)=>{
		this.setState( ()=>{
			var newState = {};
			newState[modelName] = newValue;
			return newState;
		});
	}

	/* Validation réponses étape actuel */
	passedValidation = ()=>{
		let passedValidation = true;
		let newErrorMessage = [];

		if ( this.state.step === 1 && this.state.statutMarital === "" && this.state.enCouple) {
			newErrorMessage.push (" Veuillez renseigner votre statut marital.");
			passedValidation = false;
		}
		if (this.state.step === 2 && this.state.hasEnfant 
			  && (this.state.nombreEnfant <0 || isNaN(this.state.nombreEnfant)) 
			  && this.state.nombreEnfant !== ""
			) {
			newErrorMessage.push( "Veuillez renseigner un nombre d'enfants à charge valide.")
			passedValidation = false;
		}

		// Validation RFR

		if ( this.state.step===2 && (isNaN(this.state.montantRFR) || this.state.montantRFR === "" || this.state.montantRFR < 0)){
			newErrorMessage.push( "Veuillez  indiquez un montant valide pour votre RFR.")
			passedValidation = false;
		}
		
		if (this.state.step===2 && (this.state.nombreEnfant === "" || this.state.nombreEnfant < 0 || isNaN(this.state.nombreEnfant))){
			passedValidation = false;
			newErrorMessage.push( "Indiquez le nombre d'enfants à votre charge.");
		}

		if (this.state.step === 3 && (this.state.utiliseVoiture === null || typeof this.state.utiliseVoiture === 'undefined') ){
			newErrorMessage.push( " Veuillez renseigner si vous utilisez votre voiture pour aller au travail.");
			passedValidation = false;
		}

		if (this.state.step === 3 
			&& (this.state.conjointUtiliseVoiture === null) 
			&& this.state.enCouple 
			&& this.state.statutMarital !== 'non_renseigne'  ){
			newErrorMessage.push( " Veuillez renseigner si votre conjoint(e) utilise sa voiture pour aller au travail.");
			passedValidation = false;
		}

		this.setState( ({errorMessage})=>{
			return {errorMessage : newErrorMessage};
		})

		return passedValidation;
	}

	/*nombre de parts pour individus*/
	calculPartIndividu = (nombreEnfant)=> {
		nombreEnfant = nombreEnfant === "" ? 0 : nombreEnfant;
		if (nombreEnfant === 0) {
		        var parts = 1;
		  	} else if (nombreEnfant === 1) {
		        var parts = 1.5;
		    } else if (nombreEnfant === 2) {
		        var parts = 2;
		    } else if (nombreEnfant === 3) {
		        var parts = 3;
		    } else {
		        var parts = 3 + (nombreEnfant - 3);
		    }
		return parts;
	}
	/* */
	calculPartCouple = ( nombreEnfant) =>{
		nombreEnfant = nombreEnfant === "" ? 0 : nombreEnfant;
		if (nombreEnfant === 0) {
		        var parts = 2;
		    } else if (nombreEnfant === 1) {
		        var parts = 2.5;
		    } else if (nombreEnfant === 2) {
		        var parts = 3;
		    } else if (nombreEnfant === 3) {
		        var parts = 4;
		    } else {
		        var parts = 4 + (nombreEnfant - 3);
		    }
		return parts;
	}
	/* Calcul le droit a l'indemnité carburant*/
	hasDroitIndemniteCarburant = () => {
		const {enCouple,nombreEnfant,montantRFR,utiliseVoiture,statutMarital} = this.state;

		if ( ! this.state.utiliseVoiture 
			  && (!enCouple || statutMarital === "non_renseigne")
			) {
			return false;
		}else if ( enCouple 
			  && statutMarital!=="non_renseigne" 
			  && !this.state.conjointUtiliseVoiture 
			  && !this.state.utiliseVoiture
			){
			return false;
		}
		

		/* calcul part rfr */
		const {calculPartIndividu,calculPartCouple} = this;

		if (enCouple && statutMarital !== 'non_renseigne') {
		    var parts = calculPartCouple(nombreEnfant);
		    var rfr =  montantRFR;

		} else {
		    var parts = calculPartIndividu(nombreEnfant)
		    var rfr = montantRFR;
		}
		
		// Si le ré(sultat est inférieur ou égal à 14 700 € : réponse positive
		//Le nouveau plafond est 17.905€ (il était de 14.700€ auparavant)
		return rfr/parts <= 17905;
	}
	calculDroitIndemnite = ()=>{
		return (this.state.conjointUtiliseVoiture ? 100 : 0) + (this.state.utiliseVoiture? 100: 0);
	}
	/* Aller a la prochaine étape*/
	nextStep = ()=>{
		if ( this.passedValidation()){
			if ( (this.state.step +1 ) === 4 ) {
				this.hasDroitIndemniteCarburant();
			}
			this.setState(({step})=>{
				return {step : step+1};
			} )
		}
	}

	restart = ()=>{
		this.setState( ()=>(

		{
			utiliseVoiture: null,
			conjointUtiliseVoiture :null,
			hasEnfant :false,
			nombreEnfant :"" ,

			enCouple:false,
			montantRFR : "",
			statutMarital:"",
			step : 0,
			optionsStatutMarital: [

			    { 
			      id: 1,
			      name: 'En Union Libre',
			      value :'non_renseigne',
			    },
		        {
		          id: 2,
		          name: 'Marié-e',
		          value:'marie',
		      	},
		        {
		          id: 3,
		          name: 'Pacsé-e',
		          value: 'pacse',
		      	}
			],
			errorMessage :[],
		}
		));
	}

	render () {

		const {
			utiliseVoiture,
			conjointUtiliseVoiture,
			enCouple,
			montantRFR,
			step,
			optionsStatutMarital,
			statutMarital,
			nombreEnfant,
			errorMessage

		} = this.state;

		const {
			captureUseVoiture ,
			captureUseVoitureConjoint,
			nextStep ,
			handleChangeEnCouple,
			captureStatutMarital,
			handleChangeHasEnfant ,
			captureNombreEnfant,
			handleMontantChange,
			hasDroitIndemniteCarburant

		} = this;

		const year = new Date().getFullYear();
		const stepCouple  = <>
			<div className="question question-couple">
					<RadioBox 
						name="enCouple"
						options={{"En couple":true, "Seul":false}}
						handler={handleChangeEnCouple}
						defaultValue={this.state.enCouple}
					><h3> Vivez-vous seul(e) ou en couple ?</h3></RadioBox>
				</div>

				{ (enCouple) ? 
				<div className="question statut-couple">
					<h3><label > Quel est le statut de votre couple ?</label></h3>
					<select value={statutMarital} onChange={captureStatutMarital} >
						<option value="" selected disabled>Sélectionnez le statut de votre couple</option>
						{optionsStatutMarital.map( (option)=>(
							<option key={option.id} value={option.value}>{option.name}</option>
						))}
					</select>
				</div> : ''}
		</>;

		let messageInfo = <><h4>Où trouver votre RFR ?</h4><p>Il apparaît sur la 1ère page de votre avis d'imposition 2023 dans la rubrique "vos références" sous l'appellation revenu fiscal de référence</p></>

		const stepRFR = <>
			<div className="question question-rfr">
								
					<MontantInput
						name="rfr"
						model={montantRFR}
						modelName="montantRFR"
						handler={handleMontantChange}
					> Indiquez votre RFR 2022 (sur l’avis d’imposition de 2023) : <InfoBulle message={messageInfo}/>
					</MontantInput>

					
			</div>
			<div className="question nombreEnfant" >
				<label>Combien d’enfants à charge apparaissent sur votre déclaration ? </label><br/>
				<input 
					name="nombreEnfant" 
					type="number"
					placeholder="Ex : 2"
					onChange={captureNombreEnfant}
					value={nombreEnfant}
				/>
			</div>
			{ (statutMarital === "non_renseigne") ?
				<div className="text-info">
					<i><p>Les couples en union libre sont considérés comme des personnes célibataires pour l'administration fiscale. Ainsi, vos droits à l'indemnité carburant sont calculés uniquement à partir de votre Revenu Fiscal de Référence.
					</p></i>
				</div>
			:""}
		</>;

		const stepVoiture = <>
			<RadioBox 
				name="utilise-voiture"
				options={{"Oui":true ,"Non":false}}
				handler={captureUseVoiture}
				defaultValue={utiliseVoiture}

			><h3>Utilisez-vous votre voiture pour aller au travail ?</h3></RadioBox>
			{
				(enCouple && statutMarital !=='non_renseigne') ? 
				<RadioBox 
					name="voiture-conjoint"
					options={{"Oui":true ,"Non":false}}
					handler={captureUseVoitureConjoint}
					defaultValue={conjointUtiliseVoiture}

				><h3>Est-ce que votre conjoint(e) utilise sa voiture pour aller au travail ?</h3></RadioBox>
				: ""

			}
		</>;

		return <div className="Simulateur">
			<div 
				className={"step-inner-container famille " + (step === 0	? 'show' : 'hide')}
			>
				<Startscreen nextStep={nextStep} />
			</div>

			<div className={"step-container" + (step === 4 || step === 0 ? 'hide' : '') }>
				<div 
					className={"step-inner-container couple " + (step === 1	? 'show' : 'hide')}
				>	<img src={triangle} alt="triangle" style={{display:'block', marginTop:'5px'}} className="desktop-only" />
					<img src={trianglebas} alt="triangle" style={{ marginLeft:'5px'}} className="mobile-only trianglebas" />
					{stepCouple}
				<img src={logo} className="logo" style={{display:'block' , position:'absolute' , left:'10px', bottom:'10px'}}/>
					
				</div>

				
				<div 
					className={"step-inner-container rfr " + (step===2 ? 'show' : 'hide')}
				> <img src={triangle} alt="triangle" style={{display:'block', marginTop:'5px'}} className="desktop-only" />
				<img src={trianglebas} alt="triangle" style={{ marginLeft:'5px'}} className="mobile-only trianglebas" />
					{stepRFR}
					<img src={logo} className="logo" style={{display:'block' , position:'absolute' , left:'10px', bottom:'10px'}}/>
				</div>
				
				
				<div 
					className={"step-inner-container voiture "	+ (this.state.step===3 ? 'show' : 'hide')}
				><img src={triangle} alt="triangle" style={{display:'block', marginTop:'5px'}}  className="desktop-only"/>
				<img src={trianglebas} alt="triangle" style={{ marginLeft:'5px'}} className="mobile-only trianglebas" />
					
					{stepVoiture}
					<img src={logo} className="logo" style={{display:'block' , position:'absolute' , left:'10px', bottom:'10px'}}/>
				</div>

				<FormError errors={errorMessage} />
				{(step !== 0 && step !== 4 ) ?
					<div className= "button-container">
						<button  className="btn btn-next" onClick={nextStep}> Suivant</button>
						<div className="restart-container" >
						<button className="btn restart-btn" onClick={this.restart} >Recommencer</button>
						</div>
					</div> : ""
				}
			</div>

			{ (step === 4) ?

					<div className ="step-inner-container">
					 	<ResultScreen
					 		restart={this.restart}
					 		positif={hasDroitIndemniteCarburant()}
					 		unionLibre={(statutMarital==="non_renseigne")}
					 		montant={this.calculDroitIndemnite()} couple={enCouple}
					 	/>
					</div>
					:""
				}
		</div>
	}
}

export default Simulateur;